<template>
  <div class="item" @click="$event.stopPropagation()">
    <div class="ui checkbox">
      <input type="checkbox" v-model="column.visible">
      <label>{{column.title}}</label>
    </div>
  </div>
</template>

<script>
  export default {
    name: "column-param-item",
    props:{
      column:{
        type:Object,
      }
    }
  }
</script>

<style scoped>

</style>
